import { DocumentPack } from '@/interfaces/documentPack';
import { DocumentPackResource, documentPackResource } from '@/resources/documentPack.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł paczek dokumentów
 *
 * @export
 * @class DocumentPackModule
 * @extends {EntityModule<DocumentPack, DocumentPackResource>}
 */
export class DocumentPackModule extends EntityModule<DocumentPack, DocumentPackResource> {
  constructor() {
    super(documentPackResource);

    this.actions = {
      ...this.actions,

      /**
       * Odbiera paczkę dokumentów
       *
       * @param {*} context
       * @param {number} id
       */
      receive: (context: any, data: { id: number; packMdokId: number }): Promise<any> => this.resource.receive(data)
    };
  }
}

export default new DocumentPackModule();
